import customerService from "@/services/customer";
import { useInfiniteQuery } from "@tanstack/react-query";

const PAGE_SIZE = 10;

const useGetInvoicesInfinite = () =>
  useInfiniteQuery({
    queryKey: ["invoices", "mobile", PAGE_SIZE],
    queryFn: ({ pageParam = 0 }) =>
      customerService.getInvoices({
        Count: PAGE_SIZE,
        Skip: pageParam,
      }),
    getNextPageParam: (lastPage, pages) => {
      const loadedCount = pages.reduce(
        (total, page) => total + page.result.length,
        0,
      );

      if (typeof lastPage.count === "number") {
        return loadedCount < lastPage.count ? loadedCount : undefined;
      }

      return lastPage.result.length === PAGE_SIZE ? loadedCount : undefined;
    },
  });

export default useGetInvoicesInfinite;
